import simpleDate  from './simpleDate'
import isSameMonth from 'date-fns/isSameMonth'

import { split, join, init, o } from 'ramda'

function simpleDateRange ([ a, b ]: [ Date, Date ], weekday = false): string {
	const dot  = '.'
	const fn   = (s: string, x: Date) => split(s)(simpleDate(x, weekday))
	const from = fn(dot, new Date(a))
	const to   = fn(dot, new Date(b))
	//@ts-ignore
	return isSameMonth(a, b) && !weekday ? `${o( join(dot), init )(from)}. – ${join(dot, to)}` : `${join(dot, from)} – ${join(dot, to)}`
}

export default simpleDateRange